/**
 * @fileoverview タイトルのコンポーネント
 * */
import { useLocation } from "react-router-dom";
import "./Title.css";
import LanguageSelector from "./LanguageSelector";

/**
 * タイトル
 * @returns {JSX.Element} タイトルのJSX要素
 */
export function Title(): JSX.Element {
  const location = useLocation();
  const { pathname } = location;

  const titles: { [key: string]: JSX.Element } = {
    "/anasys": (
      <>
        <h1 className="p-heading__h1">ANASYS</h1>
        <LanguageSelector />
      </>
    ),
    "/cmcd-200": (
      <h1 className="p-heading__h1">
        一酸化炭素・二酸化炭素測定器 CMCD-200
        <br />
        ソフトウェアダウンロードページ
      </h1>
    ),
    "/gas-log-reader": (
      <h1 className="p-heading__h1">
        ロギングデータ読み取りソフト
        <br />
        GasLogReaderダウンロードページ
      </h1>
    ),
  };

  const defaultTitle = (
    <h1 className="p-heading__h1">ガステックソフトウェアダウンロードページ</h1>
  );

  const matchedTitle = Object.keys(titles).find((key) =>
    pathname.startsWith(key)
  );

  return <>{matchedTitle ? titles[matchedTitle] : defaultTitle}</>;
}
